import React from "react";
import { Mail, Phone, MapPin, ArrowUp } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT } from "@/lib/site";

export const Footer = () => {
  const year = new Date().getFullYear();
  const backToTop = () => {
    document.querySelector('[data-testid="logo-link"]')?.focus({ preventScroll: true });
    window.scrollTo({ top: 0, behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth" });
  };

  return (
    <footer data-testid="site-footer" className="relative overflow-hidden text-slate-600">
      {/* Subtle background watermark */}
      <div
        aria-hidden="true"
        className="pointer-events-none select-none absolute inset-x-0 bottom-0 flex items-end justify-center overflow-hidden"
      >
        <span className="font-heading font-bold tracking-tighter text-brand/[0.05] text-[clamp(4.5rem,18vw,14rem)] leading-[0.75] translate-y-[22%] whitespace-nowrap">
          Sphere IT Solutions
        </span>
      </div>

      <div className="relative mx-auto max-w-7xl px-6 lg:px-12 py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-12">
          {/* Brand */}
          <div className="min-w-0 lg:col-span-5">
            <div className="text-slate-900">
              <Logo />
            </div>
            <p className="mt-5 text-sm leading-relaxed text-slate-600 max-w-xs">
              Specialist core banking consulting for banks and financial
              institutions — architecture, migration, integration and managed support.
            </p>
          </div>

          {/* Contact */}
          <div className="min-w-0 lg:col-span-4">
            <h4 className="text-slate-900 font-heading font-semibold text-sm mb-4">Get in touch</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-brand shrink-0" />
                <a href={`mailto:${CONTACT.email}`} className="break-all hover:text-brand transition-colors">{CONTACT.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-brand shrink-0" />
                <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="hover:text-brand transition-colors">{CONTACT.phone}</a>
              </li>
              {CONTACT.offices.map((o) => (
                <li key={o.city} className="flex items-start gap-3">
                  <MapPin className="w-4 h-4 mt-0.5 text-brand shrink-0" />
                  <span>
                    {o.lines.map((line) => (
                      <span key={line} className="block">{line}</span>
                    ))}
                  </span>
                </li>
              ))}
            </ul>
          </div>
          <button type="button" onClick={backToTop} data-testid="footer-back-to-top"
            className="footer-back-to-top justify-self-end self-start md:col-span-2 lg:col-span-3 inline-flex items-center gap-2 rounded-full bg-brand px-5 py-3 font-semibold text-white shadow-md hover:bg-brand-hover transition-colors">
            Back to top <ArrowUp className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="relative">
        <div className="mx-auto max-w-7xl px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© {year} Sphere IT Solutions. All rights reserved.</p>
          <p>Developed and maintained by Navaoi</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
